import { useQueryClient } from '@tanstack/react-query';
import { useEffect, type ReactNode } from 'react';
import { SetupTourProvider } from './core/SetupTourProvider';
import { SETUP_TOUR_COMPLETION_CHANGED_EVENT } from './core/onboardingService';
import { setupTourRegistry } from './definitions/registry';
import { QUICK_START_QUERY_KEY } from './hooks/useQuickStartGuide';

export const SetupToursProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const invalidateQuickStart = (): void => {
      void queryClient.invalidateQueries({ queryKey: QUICK_START_QUERY_KEY });
    };

    window.addEventListener(SETUP_TOUR_COMPLETION_CHANGED_EVENT, invalidateQuickStart);
    return () =>
      window.removeEventListener(SETUP_TOUR_COMPLETION_CHANGED_EVENT, invalidateQuickStart);
  }, [queryClient]);

  return <SetupTourProvider registry={setupTourRegistry}>{children}</SetupTourProvider>;
};
